import { ViewContext } from './view-context';

export class FilterNameChangeMapper {
  private _list: { oldName: string; newName: string; viewContext: ViewContext }[] = [
    { oldName: 'Status', newName: 'Profile Status', viewContext: ViewContext.People },
    {
      oldName: 'Submitted Forms',
      newName: 'Submitted Lineup Forms',
      viewContext: ViewContext.People,
    },
    { oldName: 'Rating', newName: 'Evaluation Rating', viewContext: ViewContext.People },
  ];
  constructor(public viewContext: ViewContext) {}
  public map(name: string): string {
    let result = this._list.find((x) => x.oldName == name && x.viewContext == this.viewContext);
    if (!result) return name;
    return result.newName;
  }
}
